import { zergApi } from "@/service/zerg";

class ClientsService {

    async getClients(params) {
        try {
            const data = await zergApi.post("/setting/clients/get-clients", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataClientById(params) {
        try {
            const data = await zergApi.post("/setting/clients/get-data-client-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDocumentTypes(params) {
        try {
            const data = await zergApi.get("/rrhh/employee/get-document-types", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async registerClient(params){
        try {
            const data = await zergApi.post("/setting/clients/register-client", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateClient(params){
        try {
            const data = await zergApi.post("/setting/clients/update-client", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async inactiveClient(params){
        try {
            const data = await zergApi.post("/setting/clients/inactive-client", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getClientsForSelect(){
        try {
            const data = await zergApi.post("/setting/clients/get-clients-for-select");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getServiceTypesForSelect(params){
        try {
            const data = await zergApi.post("/setting/clients/get-service-types-for-select",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async registerServiceType(params){
        try {
            const data = await zergApi.post("/setting/clients/register-service-type",params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new ClientsService();